import { Box } from '@mui/material'
import Contenitore from 'components/ui/Contenitore'

export default function FrontofficeContenitore(props) {
  const { children, ...rest } = props

  return (
    <Contenitore {...rest}>
      <Box sx={{ mt: 2, ml: { sm: 2, lg: 4 } }}>
        {children}
      </Box>
    </Contenitore>
  )
}